<template>
  <button type="button"
    class="border-0 inline-block rounded-lg px-6 py-2 text-xs font-medium text-white uppercase ring-0 outline-none focus:ring-0 hover:shadow-lg transition-shadow">
    <slot />
  </button>
</template>

<script lang="ts" setup>

</script>

<style></style>